import React from "react";

const Footer = () => {
    return (
        <footer className="bg-black border-t border-rose-300 py-6 text-center">
            <div className="container mx-auto px-4">
                <p className="text-rose-300 text-sm md:text-base">&copy; 2025 De Vānā Designs. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
